import React from 'react';

// value/onChange work with an array of selected weekday indices (0=Mon..6=Sun), multiselect
const DaysOfWeekPicker = ({ value = [], onChange, label = "Days" }) => {
    const days = [
        { label: 'Mon', index: 0 },
        { label: 'Tue', index: 1 },
        { label: 'Wed', index: 2 },
        { label: 'Thu', index: 3 },
        { label: 'Fri', index: 4 },
        { label: 'Sat', index: 5 },
        { label: 'Sun', index: 6 },
    ];

    const selectedValues = Array.isArray(value) ? value : [];
    const allSelected = days.every(day => selectedValues.includes(day.index));

    const toggleDay = (index) => {
        const isSelected = selectedValues.includes(index);
        const updated = isSelected
            ? selectedValues.filter(day => day !== index)
            : [...selectedValues, index];
        onChange(updated);
    };

    const toggleAll = () => {
        onChange(allSelected ? [] : days.map(day => day.index));
    };

    return (
        <div>
            <label className="block text-sm font-medium text-custom-light-grey mb-3">
                {label}
            </label>

            <div className="flex rounded-lg bg-custom-dark/30 divide-x divide-custom-charcoal overflow-hidden">
                <button
                    type="button"
                    onClick={toggleAll}
                    className={`flex-1 flex items-center justify-center py-3 transition-colors duration-150 ${
                        allSelected
                            ? 'bg-custom-light-blue text-custom-dark'
                            : 'text-custom-light-grey hover:bg-custom-charcoal/50'
                    }`}
                >
                    <span className="text-xs font-semibold">All</span>
                </button>
                {days.map((day) => {
                    const isSelected = selectedValues.includes(day.index);

                    return (
                        <button
                            key={day.index}
                            type="button"
                            onClick={() => toggleDay(day.index)}
                            className={`flex-1 flex items-center justify-center py-3 transition-colors duration-150 ${
                                isSelected
                                    ? 'bg-custom-light-blue text-custom-dark'
                                    : 'text-custom-light-grey hover:bg-custom-charcoal/50'
                            }`}
                        >
                            <span className="text-xs font-semibold">{day.label}</span>
                        </button>
                    );
                })}
            </div>
        </div>
    );
};

export default DaysOfWeekPicker;
